<template>
  <v-sheet height="100%" width="100%" color="transparent">
    <Title>{{ vinheta }}</Title>

    <v-container>
      <div class="pb-12 pb-lg-16 properties-grid">
        <div class="mt-8 mt-md-12">
          <Search />
        </div>
        <div class="mt-8 mt-md-12">
          <v-sheet
            v-if="loading"
            class="d-flex justify-center align-center"
            height="100%"
            width="100%"
            color="transparent"
          >
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </v-sheet>
          <v-sheet v-else>
            <v-sheet v-if="items.length">
              <div
                class="
                  align-center
                  d-flex
                  flex-column flex-md-row
                  justify-space-between
                "
              >
                <div
                  class="text-h6 text-sm-h5 text-md-h4 text-lg-h3 mb-5"
                  v-html="textTotalItems"
                ></div>
                <div class="mb-5">
                  <v-select
                    outlined
                    v-model="orderBy"
                    hide-details
                    height="40px"
                    :items="[
                      {
                        text: 'Padrão',
                        value: 'padrao',
                      },
                      {
                        text: 'Menor Preço',
                        value: 'menor-preco',
                      },
                      {
                        text: 'Maior Preço',
                        value: 'maior-preco',
                      },
                      {
                        text: 'Mais Quartos',
                        value: 'mais-quartos',
                      },
                      {
                        text: 'Menos Quartos',
                        value: 'menos-quartos',
                      },
                    ]"
                    label="Ordenar por"
                  ></v-select>
                </div>
              </div>
              <div class="properties-grid-list">
                <div
                  class="properties-grid-item"
                  v-for="(item, i) in items"
                  :key="i"
                >
                  <properties :item="item" />
                </div>
              </div>
            </v-sheet>
            <div v-else>
              <v-alert prominent class="primary white--text mt-8">
                <v-row align="center">
                  <v-col class="grow">
                    <v-icon class="white--text text--darken-3 mb-1 mr-2">
                      fa fa-exclamation-circle
                    </v-icon>
                    Nenhum conteúdo encontrado.
                  </v-col>

                  <v-col class="shrink">
                    <v-btn class="primary darken-3 white--text" :to="path">
                      Todos os Imóveis
                    </v-btn>
                  </v-col>
                </v-row>
              </v-alert>
            </div>
          </v-sheet>
        </div>
      </div>

      <v-pagination
        class="pagination mt-8"
        v-model="page"
        :length="pagesLength"
        :total-visible="9"
        v-if="pagesLength > 1"
      ></v-pagination>
    </v-container>
  </v-sheet>
</template>

<script>
import { formatPrice } from "../../../utils/formatPrice";
import { formatToURL } from "../../../utils/formatToURL";
import Properties from "../../cards/Properties.vue";
import Search from "../../forms/Properties.vue";
import Title from "../../widgets/Title.vue";

const _config = {
  path: `/imoveis`,
  mod: `properties`,
};

export default {
  data: () => ({
    loading: true,
    path: _config.path,
    orderBy: "padrao",
    items: [],
    textTotalItems: "",
    itemsPerPage: 24,
    totalItems: 0,
  }),
  computed: {
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    filters() {
      return this.$route.query;
    },
    vinheta() {
      return "Imóveis";
    },
  },
  methods: {
    get() {
      this.loading = true;

      const params = {
        itemsPerPage: this.itemsPerPage,
        returnTotalItems: 1,
        ...this.filters,
      };

      this.$rest(_config.mod)
        .get({
          params,
          keepCache: true,
          save: (state, { totalItems, list }) => {
            this.items = list.map(
              ({
                id,
                img,
                title,
                business,
                district,
                price,
                ref,
                garage,
                bedrooms,
              }) => ({
                img: this.files + img + "?resize=1&w=400",
                title,
                to: `${this.path}/${formatToURL(title)}-${id}`,
                business,
                district,
                price: price ? formatPrice(price) : "",
                ref,
                garage,
                bedrooms,
              })
            );

            this.totalItems = totalItems;

            this.textTotalItems =
              totalItems > 0
                ? `<b>${totalItems}</b> resultado` + (totalItems > 1 ? `s` : ``)
                : "OPS! nenhum imóvel encontrado.";

            if (!list.length && this.page > 1) this.page = 1;
          },
        })
        .then(() => (this.loading = false));
    },
  },
  mounted() {
    this.get();
  },
  watch: {
    $route() {
      this.get();
    },
    orderBy() {
      const query = { ...this.$route.query };

      if (this.orderBy !== "padrao") query.ordenar = this.orderBy;
      else delete query.ordenar;

      this.$router.push({ query });
    },
  },
  components: {
    Title,
    Search,
    Properties,
  },
};
</script>

<style lang="scss" scoped>
.properties-grid {
  display: grid;
  gap: 30px;
  grid-template-columns: 270px auto;
  @media screen and (max-width: 1264px) {
    gap: 30px 10px;
  }
  @media screen and (max-width: 960px) {
    gap: 10px;
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
  .properties-grid-list {
    display: grid;
    gap: 30px;
    grid-template-columns: 1fr 1fr 1fr;
    @media screen and (max-width: 1264px) {
      gap: 30px 10px;
      grid-template-columns: 1fr 1fr;
    }
    @media screen and (max-width: 960px) {
      gap: 10px;
    }
    @media screen and (max-width: 750px) {
      grid-template-columns: 1fr;
    }
    @media screen and (max-width: 600px) {
      grid-template-columns: 1fr 1fr;
    }
    @media screen and (max-width: 424px) {
      grid-template-columns: 1fr;
    }
  }
}
</style>
